export const DATE_FORMAT_COMMON = 'DD-MM-YYYY';

export const DATE_FORMAT_AMERICAN_TYPE = 'MM-DD-YYYY';

export const DATE_FORMAT_ASIAN_TYPE = 'YYYY-MM-DD';
